export const RETRY_COUNT_MAX = 3;
export const RETRY_TIMEOUT = 6000;
export const TERMINATE_DEFAULT_ERROR_MESSAGE =
  'An error has occurred. Please check you have the correct permissions to terminate this workflow and try again.';



// WEBPACK FOOTER //
// ./client/routes/workflow/constants.js